
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { Executive } from 'Types/PersonTypes';
import {
  backgroundColorParsing, valueToObject,
} from 'Utils/UtilityFunctions';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';

import HeadingWithToolTip from 'Components/common/components/HeadingWithToolTip';
import { TOOLTIP_TOPPEOPLE } from 'Utils/Constants';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { useDispatch } from 'react-redux';
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import {
  primaryFont, primaryHeadingColor, maxWidth, retina, maxTablet,
  wMLight,
} from '../../../Utils/utilsStyle';



const StyleWrapper = styled.div`
  .fancy-box {
    h4 {
      font-family: ${primaryFont};
      color: ${primaryHeadingColor};
      font-size: 18px;
      font-weight: ${wMLight};
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 16px;
      }
      @media all and (max-width: ${maxTablet}) {
        margin-bottom: 0px;
        font-size: 13px;
      }
    }
  }
  .people-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
  .people-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
  .people-row-grid {
    @media all and (max-width: ${maxTablet}) {
      padding-top: 8px;
    }
  }
`;

type Props = {
  executives: Executive[],
  loading: boolean
};

const TopCompany = function TopCompany(props: Props) {
  const { executives, loading } = props;
  const dispatch = useDispatch();
  const host = window.location.href;

  const handleClick = ({ personName, personId, executiveType }: Executive) => {
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('feedpage_topPeople_clicked', 0, {
        person_id: personId,
        person_name: personName,
        type: executiveType,
        host,
      }),
    ));
  };

  return (
    <StyleWrapper>
      <div className="fancy-box">
        {loading ? <SkeletonCustom height="20px" width="200px" margin="0px 0px 10px 0px" />
          : executives.length > 0
          && (
            <h4 className="d-flex align-items-center">
              Top People
              <HeadingWithToolTip
                widthIcon="16px"
                heightIcon="18px"
                widthIconSm="12px"
                heightIconSm="18px"
                toolTipText={TOOLTIP_TOPPEOPLE}
                classNameOverlay="right-tip"
              />
            </h4>
          )}
        <div>
          <Row gutter={[5, 5]} className="wrap-slider hidden-scroll people-row-grid">
            {loading ? (
              <span className="resolution-fix for-people">
                <SkeletonCustom width="90px" height="90px" diameter="50%" />
                <SkeletonCustom width="90px" height="90px" diameter="50%" />
                <SkeletonCustom width="90px" height="90px" diameter="50%" />
                <SkeletonCustom width="90px" height="90px" diameter="50%" />
              </span>
            )
              : executives.length > 0 && executives.map((item) => (
                <Col className="gutter-row d-flex justify-content-center">

                  <div
                    onClick={() => handleClick(item)}
                    onKeyPress={() => handleClick(item)}
                    tabIndex={0}
                    role="button"
                  >
                    <PeopleWidgetWithOutHolo
                      diameter="92px"
                      diameterSm="75px"
                      diameterXsm="52px"
                      wrapperColor={backgroundColorParsing(item.personalityTypes)}
                      logo={item.personImage}
                      persona={item.archeType.color}
                      personId={item.personId}
                      showPersonName
                      personName={item.personName}
                      personForHover
                      personDesignation={item.personDesignation}
                      ringPadding="3px"
                      ringPaddingSm="3px"
                      classNameWrapper="showSmallInXs"
                      topPeopleNutanix
                    />
                  </div>

                </Col>
              ))}
          </Row>
        </div>
      </div>
    </StyleWrapper>
  );
};

export default TopCompany;
